import {FC, useCallback, useMemo, useState} from 'react'
import {
    initialValuesProducts,
    ProductsContext,
    ProductsObjectInterface,
    PropsProducts,
    RequestProducts,
} from '../types'
import {ActiveProductsType} from '../../modules/auth/models/UserModel'
import {Get} from '../../../setup'
import {useQuery} from 'react-query'
import {Encrypt} from '../../features'
import {useDispatch} from 'react-redux'
import {productsReducer}  from "../../@reducer"
import {LoadingState} from '../../../global'

const PRODUCTS_ENDPOINT = process.env.REACT_APP_GET_PRODUCTS || 'list-products'

const mapProducts = (
    products: ProductsObjectInterface,
    data: RequestProducts,
): PropsProducts[] => {
    return Object.values(products)
        .filter(product =>
            Object.values(data).some(
                item => item.products.toLowerCase() === product.name.toLowerCase(),
            ),
        ).map(product => {
            const matchingData = Object.values(data).find(
                item => item.products.toLowerCase() === product.name.toLowerCase(),
            )

            return {
                name: product.name,
                date: product.activated_at || '',
                description: product.description.trim() || '',
                status: Boolean(product.activated_at),
                treaty: matchingData?.trait || 0,
                display_name: product.display_name || ''
            }
        })
}

const createMappedProduct = (product: any, initialProduct: any) => ({
    ...product || initialProduct,
    encrypted: Encrypt(product?.activated_at || initialProduct.activated_at)
})

const ProductsProvider: FC = ({children}) => {

    const dispatch = useDispatch();
    const [reloadKey, setReloadKey] = useState<number>(0)
    const [productsActive, setProductsActive] = useState<ProductsObjectInterface>(initialValuesProducts.products)
    const [requestProducts, setRequestProducts] = useState<PropsProducts[]>([])
    const [loadingState, setLoadingState] = useState<LoadingState>('idle')

    useQuery(
        ['REQUEST_PRODUCTS', reloadKey],
        () => {
            setLoadingState('pending')
            return Get<{demandeProducts: RequestProducts, products_active: ActiveProductsType}>({endpoint: PRODUCTS_ENDPOINT})
        },
        {
            onSuccess: ({demandeProducts, products_active}) => {

                const mappedProducts: ProductsObjectInterface = {
                    callTracking: createMappedProduct(products_active?.Calltraking, initialValuesProducts.products.callTracking),
                    webForms: createMappedProduct(products_active?.Webformulaires, initialValuesProducts.products.webForms),
                    mailing: createMappedProduct(products_active?.Mailing, initialValuesProducts.products.mailing),
                    statistics: createMappedProduct(products_active?.Statistiques, initialValuesProducts.products.statistics),
                    reputation: createMappedProduct(products_active?.Ereputaion, initialValuesProducts.products.reputation),
                    sav: createMappedProduct(products_active?.Sav, initialValuesProducts.products.sav),
                    updatePlugins: createMappedProduct(products_active?.UpdatePlugins, initialValuesProducts.products.updatePlugins),
                    documents: createMappedProduct(products_active?.documents, initialValuesProducts.products.documents),
                    conversionClicks: createMappedProduct(products_active?.ConversionClicks, initialValuesProducts.products.conversionClicks),
                    contacts: createMappedProduct(products_active?.Contacts, initialValuesProducts.products.contacts),
                    reviews: createMappedProduct(products_active?.Reviews, initialValuesProducts.products.reviews),
                }

                setProductsActive(mappedProducts)
                const updatedProducts = mapProducts(mappedProducts, demandeProducts)
                setRequestProducts(updatedProducts)
                dispatch(productsReducer.actions.setProductsActive(mappedProducts))
                setLoadingState('fulfilled')

            },
            onError: () => {
                setLoadingState('rejected')
            }
        },

    )

    const triggerReload = useCallback(() => {
        setReloadKey(prev => prev + 1)
    }, [])

    const contextValue = useMemo(() => ({
        products: productsActive,
        requestProducts,
        reloadKey,
        triggerReload,
        loadingState
    }), [productsActive, requestProducts, reloadKey, triggerReload, loadingState])

    return (
        <ProductsContext.Provider value={contextValue}>
            {children}
        </ProductsContext.Provider>
    )
}

export {ProductsProvider}